import React from 'react';
import { Menu, Phone } from 'lucide-react';
import { Button } from './Button';
import { Sheet, SheetContent, SheetTrigger } from './Sheet';
import { Logo } from './Logo';
const NAV_LINKS = [{
  name: 'Services',
  href: '#services'
}, {
  name: 'Gallery',
  href: '#gallery'
}, {
  name: 'Reviews',
  href: '#reviews'
}, {
  name: 'Service Area',
  href: '#service-area'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80 border-b border-slate-200 h-[60px] md:h-[80px] flex items-center" data-id="element-90">
      <div className="container mx-auto px-4 flex items-center justify-between h-full" data-id="element-91">
        <a href="#" className="flex items-center gap-2 shrink-0" data-id="element-92">
          <Logo data-id="element-93" />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-id="element-94">
          {NAV_LINKS.map(link => <a key={link.name} href={link.href} className="text-sm font-bold text-slate-600 hover:text-accent transition-colors uppercase tracking-wider" data-id="element-95">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-4" data-id="element-96">
          <a href="tel:254-266-9800" className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors font-bold" data-id="element-97">
            <Phone className="h-4 w-4 text-accent" data-id="element-98" />
            (254) 266-9800
          </a>
          <Button className="bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider" data-id="element-99">
            Get a Free Quote
          </Button>
        </div>

        <div className="lg:hidden flex items-center gap-4" data-id="element-100">
          <a href="tel:254-266-9800" className="text-accent p-2" data-id="element-101">
            <Phone className="h-5 w-5" data-id="element-102" />
          </a>
          <Sheet data-id="element-103">
            <SheetTrigger asChild data-id="element-104">
              <Button variant="ghost" size="icon" className="text-slate-600 hover:text-accent hover:bg-transparent" data-id="element-105">
                <Menu className="h-6 w-6" data-id="element-106" />
                <span className="sr-only" data-id="element-107">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-white border-l-slate-200 pt-16" data-id="element-108">
              <nav className="flex flex-col gap-6" data-id="element-109">
                {NAV_LINKS.map(link => <a key={link.name} href={link.href} className="text-lg font-bold text-slate-600 hover:text-accent transition-colors uppercase tracking-wider" data-id="element-110">
                    {link.name}
                  </a>)}
                <div className="h-px bg-slate-200 my-4" data-id="element-111" />
                <a href="tel:254-266-9800" className="flex items-center gap-2 text-slate-900 font-bold text-lg" data-id="element-112">
                  <Phone className="h-5 w-5 text-accent" data-id="element-113" />
                  (254) 266-9800
                </a>
                <Button className="bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider w-full h-12 mt-4" data-id="element-114">
                  Get a Free Quote
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}